import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';




import { ChatPanelModule } from 'app/layout/components/chat-panel/chat-panel.module';


import { NavbarModule } from 'app/layout/components/navbar/navbar.module';


import { VerticalLayout3Component } from 'app/layout/vertical/layout-3/layout-3.component';

@NgModule({
    imports: [
    RouterModule,
    ChatPanelModule,
    NavbarModule,
    VerticalLayout3Component,
],
    exports: [
        VerticalLayout3Component
    ]
})
export class VerticalLayout3Module
{
}
